// extracted by mini-css-extract-plugin
module.exports = {"grid":"case-grid_grid__3J0mC","minWidth":"case-grid_minWidth__3C34m"};